/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaOutboundOrderVo } from './KoreaOutboundOrderVo';
import {
    KoreaOutboundOrderVoFromJSON,
    KoreaOutboundOrderVoFromJSONTyped,
    KoreaOutboundOrderVoToJSON,
    KoreaOutboundOrderVoToJSONTyped,
} from './KoreaOutboundOrderVo';

/**
 * 
 * @export
 * @interface ResponseListKoreaOutboundOrderVo
 */
export interface ResponseListKoreaOutboundOrderVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListKoreaOutboundOrderVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListKoreaOutboundOrderVo
     */
    message?: string;
    /**
     * 
     * @type {Array<KoreaOutboundOrderVo>}
     * @memberof ResponseListKoreaOutboundOrderVo
     */
    data?: Array<KoreaOutboundOrderVo>;
}

/**
 * Check if a given object implements the ResponseListKoreaOutboundOrderVo interface.
 */
export function instanceOfResponseListKoreaOutboundOrderVo(value: object): value is ResponseListKoreaOutboundOrderVo {
    return true;
}

export function ResponseListKoreaOutboundOrderVoFromJSON(json: any): ResponseListKoreaOutboundOrderVo {
    return ResponseListKoreaOutboundOrderVoFromJSONTyped(json, false);
}

export function ResponseListKoreaOutboundOrderVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListKoreaOutboundOrderVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(KoreaOutboundOrderVoFromJSON)),
    };
}

export function ResponseListKoreaOutboundOrderVoToJSON(json: any): ResponseListKoreaOutboundOrderVo {
    return ResponseListKoreaOutboundOrderVoToJSONTyped(json, false);
}

export function ResponseListKoreaOutboundOrderVoToJSONTyped(value?: ResponseListKoreaOutboundOrderVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(KoreaOutboundOrderVoToJSON)),
    };
}

